import React, { useContext, useState } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui';
import { Switch } from '../../../../common/formik';

import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    InputAdornment,
    Button,
    CircularProgress,
    Typography,
    colors
} from '@material-ui/core';

import { 
    Select,
    FieldError
} from '../../../../common'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { SapTableNames } from '../../../../../helpers';

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/core/styles';
import { DbType } from '../../../../../helpers/Common';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    loader: {
        color: "black"
    },
    sapOk: {
        color: colors.green[500]
    },
    sapError: {
        color: colors.red[500]
    }    
}));

export const LogisticsCustomerServiceForm = (props) => {
    const classes: any = useStyles();

    const {
        state,
        getTableOptions,
        getTableOptionsWithCode,
        getTableValues, 
        getTransportationZoneOptions,       
        validateSapCode
    } = useContext(CustomerRequestContext)

    const { 
        values,
        isSavingRequest 
    } = useContext(TabsContext);

    const states = getTableValues(SapTableNames.States, values.dbType);
    
    const [isValidatingSapFPCode, setIsValidatingSapFPCode] = useState(false);
    const [isSapFPCodeOk, setIsSapFPCodeOk] = useState(null);
    const checkSapFPCodeClickHandler = async () => {
        const sapCode = values.logisticCustomerService.numberFunctionPartnerSP;
        if(sapCode) {
            setIsValidatingSapFPCode(true);
            setIsSapFPCodeOk(null);
            const isValid = await validateSapCode(sapCode, values.dbType);
            setIsSapFPCodeOk(isValid);
            setIsValidatingSapFPCode(false);
        }
    }    

    const [isValidatingSapFACode, setIsValidatingSapFACode] = useState(false);
    const [isSapFACodeOk, setIsSapFACodeOk] = useState(null);
    const checkSapFACodeClickHandler = async () => {
        const sapCode = values.logisticCustomerService.forwardingAgent;
        if(sapCode) {
            setIsValidatingSapFACode(true);
            setIsSapFACodeOk(null);
            const isValid = await validateSapCode(sapCode, values.dbType);
            setIsSapFACodeOk(isValid);
            setIsValidatingSapFACode(false);
        }
    }    

    return (
        <Card className={classes.card}>
            <CardHeader title="Logistics customer service"/>
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="logisticCustomerService.customerTypeId"                                               
                            label="Pick type"   
                            disabled={props.disabled}
                            options={getTableOptions(SapTableNames.CustomerTypes, values.dbType, null, true)}
                        />
                        <FieldError name="logisticCustomerService.customerTypeId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="logisticCustomerService.shippingConditionsId"                                               
                            label="Shipping condition *"  
                            disabled={props.disabled} 
                            options={getTableOptionsWithCode(SapTableNames.ShippingConditions, values.dbType)}
                        />
                        <FieldError name="logisticCustomerService.shippingConditionsId" errors={state.errors} />
                    </Grid>
                    {/* <Grid item xl={6} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="logisticCustomerService.numberFunctionPartnerSP"
                            label="Number function partener SP *"
                            disabled={props.disabled}
                            component={TextField}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <Button
                                            startIcon={isValidatingSapFPCode ?
                                                <CircularProgress size={20} className={classes.loader} />
                                                :
                                                <>
                                                    {isSapFPCodeOk === null ? 
                                                        ""
                                                        :
                                                        isSapFPCodeOk === true ? <CheckIcon className={classes.sapOk} /> : <CloseIcon className={classes.sapError}/>
                                                    }
                                                </>
                                            }
                                            disabled={props.disabled}
                                            onClick={checkSapFPCodeClickHandler}>
                                            Check
                                        </Button>                                                   
                                    </InputAdornment>                        
                            }}                                        
                        />
                        <FieldError name="logisticCustomerService.numberFunctionPartnerSP" errors={state.errors} />
                    </Grid> */}
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="logisticCustomerService.forwardingAgent"
                            label="Forwarding agent *"
                            disabled={props.disabled}
                            component={TextField}
                            InputProps={{
                                endAdornment:
                                    values.dbType === DbType.S4 ?
                                    <></> :
                                    <InputAdornment position="end">
                                        <Button
                                            startIcon={
                                                isValidatingSapFACode ?
                                                <CircularProgress size={20} className={classes.loader} /> :
                                                <>
                                                    {
                                                        isSapFACodeOk === null ? 
                                                        "" :
                                                        isSapFACodeOk === true ?
                                                        <CheckIcon className={classes.sapOk} /> :
                                                        <CloseIcon className={classes.sapError}/>
                                                    }
                                                </>
                                            }
                                            disabled={props.disabled}
                                            onClick={checkSapFACodeClickHandler}
                                        >
                                            Check
                                        </Button>                                                   
                                    </InputAdornment>                        
                            }}                            
                        />
                        <FieldError name="logisticCustomerService.forwardingAgent" errors={state.errors} />
                    </Grid>
                    {values.isPerfumesCategory && (
                        <Grid item xl={12} md={12} xs={12}>
                            <Select
                                name="logisticDocumentation.transportationZoneId"                                               
                                label="Transportation Zone *"   
                                disabled={props.disabled}
                                options={getTransportationZoneOptions(values.primaryAddress.countryId, values.dbType)}
                            />
                        <FieldError name="logisticCustomerService.transportationZoneId" errors={state.errors} />
                    </Grid>
                    )}
                    {values.isPerfumesCategory
                        && values.isInvoceAddressDifferentFromCustomer
                        && values.invoiceAddresses && values.invoiceAddresses.length > 0 &&
                        <>
                            {values.invoiceAddresses.map((invAddress, index) => {
                                const stateId = invAddress.address.stateId;
                                // Be aware of react state (they share the same name)
                                const stateName = states.find(x => x.tableValueId === stateId).value;
                                return (
                                    <Grid key={index} item xl={12} md={12} xs={12}>
                                        <div className={classes.invoiceAddress}>
                                            <Typography variant="overline">
                                                {`${index}`}. Invoice Address&nbsp;
                                            </Typography>
                                            <Typography variant="caption">
                                                {`"${values.invoiceAddresses[index].shipName} - ${stateName}"`}
                                            </Typography>
                                        </div>
                                        <Select
                                            name={`invoiceAddresses[${index}].transportationZoneId`}
                                            label="Transportation Zone *"
                                            disabled={props.disabled}
                                            options={getTransportationZoneOptions(invAddress.address.countryId, values.dbType)}
                                        />
                                        <FieldError 
                                            name={`shippingTransportationZones[${index}].transportationZoneId`} 
                                            errors={state.errors}
                                        />
                                    </Grid>
                                );
                            })}                                    
                        </>
                    }                
                </Grid>
            </CardContent>
        </Card>
    );
}